import React, { useState, useEffect, CSSProperties } from "react";
import { RadioValidationRule } from "types";

interface RadioOption {
  label: string;
  value: string;
}



interface RadioGroupProps {
  label: string;
  name: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  options: RadioOption[];
  rules?: RadioValidationRule;
  className?: string;
  style?: CSSProperties;
}

const RadioGroup: React.FC<RadioGroupProps> = ({
  label,
  name,
  value,
  onChange,
  options,
  rules = {},
  className = "",
  style = {},
}) => {
  const [error, setError] = useState<string | null>(null);

  const validate = (val: string) => {
    if (rules.required) {
      const msg = typeof rules.required === "string" ? rules.required : `${label} is required`;
      if (!val) return msg;
    }
    if (rules.validate) {
      const result = rules.validate(val);
      if (result !== true) return typeof result === "string" ? result : `${label} is invalid`;
    }
    return null;
  };

  useEffect(() => {
    setError(validate(value));
  }, [value]);

  return (
    <div className={className} style={style}>
      <span className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
        {label}
      </span>
      <div className="space-y-2">
        {options.map((opt) => (
          <label
            key={opt.value}
            className="flex items-center space-x-2 text-sm text-gray-900 dark:text-white"
          >
            <input
              type="radio"
              name={name}
              value={opt.value}
              checked={value === opt.value}
              onChange={onChange}
              className="w-4 h-4 text-blue-600 bg-gray-100 border-none focus:outline-none focus:ring-0 dark:bg-gray-700"
              required={!!rules.required}
              aria-invalid={!!error}
              aria-describedby={error ? `${name}-error` : undefined}
            />
            <span>{opt.label}</span>
          </label>
        ))}
      </div>
      {error && (
        <p id={`${name}-error`} className="mt-1 text-sm text-red-600 dark:text-red-500">
          {error}
        </p>
      )}
    </div>
  );
};

export default RadioGroup;

